// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationGroupId } from './FermentationGroup';
import { fermentationId } from './Fermentation';
import { fermentationProtocolId } from './FermentationProtocol';
import { scheduledActionTypeEnum } from './ScheduledActionTypeEnum';
import { scheduledActionStatusEnum } from './ScheduledActionStatusEnum';
import { operatorId } from './Operator';
import { fermentationProcedureProtocolId } from './FermentationProcedureProtocol';
import { z } from 'zod';
export const fermentationScheduledActionId = (z.number());
export const fermentationScheduledAction = z.object({
    id: fermentationScheduledActionId,
    fermentation_group_id: fermentationGroupId,
    fermentation_id: fermentationId.nullable(),
    target_protocol_id: fermentationProtocolId.nullable(),
    action_type: scheduledActionTypeEnum,
    action_config: z.unknown().nullable(),
    title: z.string().nullable(),
    notes: z.string().nullable(),
    scheduled_for: z.date(),
    reminder_sent: z.boolean(),
    status: scheduledActionStatusEnum,
    completed_at: z.date().nullable(),
    completed_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    sequence_entry_id: fermentationProcedureProtocolId.nullable(),
});
export const fermentationScheduledActionInitializer = z.object({
    id: fermentationScheduledActionId.optional(),
    fermentation_group_id: fermentationGroupId,
    fermentation_id: fermentationId.optional().nullable(),
    target_protocol_id: fermentationProtocolId.optional().nullable(),
    action_type: scheduledActionTypeEnum,
    action_config: z.unknown().optional().nullable(),
    title: z.string().optional().nullable(),
    notes: z.string().optional().nullable(),
    scheduled_for: z.date(),
    reminder_sent: z.boolean().optional(),
    status: scheduledActionStatusEnum.optional(),
    completed_at: z.date().optional().nullable(),
    completed_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    sequence_entry_id: fermentationProcedureProtocolId.optional().nullable(),
});
export const fermentationScheduledActionMutator = z.object({
    id: fermentationScheduledActionId.optional(),
    fermentation_group_id: fermentationGroupId.optional(),
    fermentation_id: fermentationId.optional().nullable(),
    target_protocol_id: fermentationProtocolId.optional().nullable(),
    action_type: scheduledActionTypeEnum.optional(),
    action_config: z.unknown().optional().nullable(),
    title: z.string().optional().nullable(),
    notes: z.string().optional().nullable(),
    scheduled_for: z.date().optional(),
    reminder_sent: z.boolean().optional(),
    status: scheduledActionStatusEnum.optional(),
    completed_at: z.date().optional().nullable(),
    completed_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    sequence_entry_id: fermentationProcedureProtocolId.optional().nullable(),
});
//# sourceMappingURL=FermentationScheduledAction.js.map